<template>
  <v-container grid-list-xl>
    <v-row wrap>
      <v-col cols="12">
        <grid-c
          :gridConfig="grid"
          title="Daftar Diklat"
          add
          search
          id-key
          filter
          refresh
          addText="Diklat"
          @refresh="load"
          @filter="filter"
          :items="items"
          footerLabel="Diklat"
          :variablePencarian="[{ key: 'Nama', value: 'nama' }]"
          @search="
            search => {
              dataPencarian = search;
              load();
            }
          "
          :page="page"
          @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
          @add="add"
          footer
        >
          <template v-slot:items="{ item }">
            <v-divider />
          </template>
        </grid-c>
      </v-col>
      <ChangeDlg ref="dlg" />
    </v-row>
  </v-container>
</template>

<script>
import { ALERT_INFO } from "@/const";
import ChangeDlg from "../../diklat/components/Form.vue";

export default {
  components: {
    ChangeDlg,
    // DetailDlg
  },
  data() {
    return {
      alert: ALERT_INFO,
      items: [],
      peran: null,
      textSearch: null,
      page: null,
      cp: 1,
      more_menu: [
        // eslint-disable-next-line
        {
          title: "Ubah",
          icon: "mdi-pencil",
          color: "orange",
          click: (i, o) => this.edit(o),
        },
        {
          title: "Hapus",
          icon: "mdi-delete",
          color: "error",
          click: (i, o) => this.hapus(o),
        }
      ],
    };
  },
  computed: {
    grid(){
      const conf = [
         {
          type: "icon",
          icon: "mdi-book-open",
          avatar: {
            size: 45,
            color: "secondary2",
            width: 50,
            height: 50
          },
          cols: 12,
          sm: 12,
          md: 1,
          lg: 1
        },
        {
          header: "Diklat",
          name: "nama",
          align: "left",
          class: "title primary--text",
          type: "string",
          cols: 12,
          sm: 12,
          md: 4,
          lg: 4
        },
        {
          header: "Tanggal Mulai",
          name: "tanggal_mulai",
          align: "left",
          class: "caption",
          type: "singledate",
          filter: "toD",
          cols: 12,
          sm: 12,
          md: 3,
          lg: 3
        },
        {
          header: "Tanggal Selesai",
          name: "tanggal_selesai",
          align: "left",
          class: "caption",
          type: "singledate",
          filter: "toD",
          cols: 12,
          sm: 12,
          md: 3,
          lg: 3
        },
        {
          header: "Aksi",
          type: "more",
          more: this.more_menu,
          cols: 1,
          sm: 1,
          md: 1,
          lg: 1
        }
      ];
      return conf
    },
    headers() {
      const a = [
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", sortable: false },
      ];
      return a;
    },
  },
  activated() {
    this.load();
  },
  methods: {
    //@vuese
    //menampilkan daftar diklat sesuai instansi aktif dan parameter yang digunakan
    load() {
      return this.$store
        .dispatch("diklat/get", {
          instansi_id: this.instansi_id,
          params: {
            page: this.cp,
            s: this.textSearch,
            peran: this.peran,
          },
        })
        .then((res) => {
          this.page = res;
          this.items = res.data;
        })
        .catch((e) => e);
    },
    filter(data) {
      this.peran = data.peran;
      this.load();
    },
    //@vuese
    //tampilkan form input diklat
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    //@vuese
    //tampilkan form edit diklat
    //@args objek diklat
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    //@vuese
    //Menghapus diklat 
    //@args objek diklat
    hapus(item) {
      this.$confirm(
        `Apakah Anda yakin akan menghapus diklat ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>`,
        {
          cancelOnly: item.laporan_accepted_count > 0 ? true : false,
        }
      )
        .then(() =>
          this.$store.dispatch("diklat/drop", {
            instansi_id: this.instansi_id,
            diklat_id: item.id,
          })
        )
        .then(() => {
          this.$info("Diklat " + item.nama + " berhasil dihapus");
        })
        .then(() => this.load())
        .catch((e) => e);
    },
  },
  watch: {},
};
</script>
